import { DEFAULT_FORM_INPUT_LABEL_CLASS_NAME } from './input-label';

const ONBOARDING_OUTLINED_INPUT_CLASS_NAME = 'outlined-input-onboarding';
const DEFAULT_OUTLINED_INPUT_CLASS_NAME = 'default-outlined-input';
const FORM_OUTLINED_INPUT_CLASS_NAME = 'form-outlined-input';
const SECONDARY_OUTLINED_INPUT_CLASS_NAME = 'secondary-outlined-input';
const LOGIN_OUTLINED_INPUT_CLASS_NAME = 'login-outlined-input';
const COMPACT_OUTLINED_INPUT_CLASS_NAME = 'compact-outlined-input';
const FORM_OUTLINED_INPUT_PROPS = {
  InputProps: {
    className: FORM_OUTLINED_INPUT_CLASS_NAME,
  },
  InputLabelProps: {
    className: DEFAULT_FORM_INPUT_LABEL_CLASS_NAME,
    shrink: true,
  },
};

export {
  ONBOARDING_OUTLINED_INPUT_CLASS_NAME,
  DEFAULT_OUTLINED_INPUT_CLASS_NAME,
  FORM_OUTLINED_INPUT_CLASS_NAME,
  FORM_OUTLINED_INPUT_PROPS,
  SECONDARY_OUTLINED_INPUT_CLASS_NAME,
  LOGIN_OUTLINED_INPUT_CLASS_NAME,
  COMPACT_OUTLINED_INPUT_CLASS_NAME,
};
